import { Box, Divider, Stack, Typography } from "@mui/material";
import { Colors } from "Components/Layout/Themes/Colors";
import { Resources, useResource } from "Translations/Resources";
import { formatCurrency } from "Utils/CurrencyUtils";

const PageResources = Resources.Customer.Pay;

type Props = {
  billAmount: number;
  tipAmount: number;
  currencyCode?: string;
  arePayPointTipsEnabled: boolean;
};

export const PaymentAmountCard = ({
  billAmount,
  tipAmount,
  currencyCode,
  arePayPointTipsEnabled,
}: Props) => {
  const { t } = useResource();
  const total = billAmount + tipAmount;
  const hasTip = tipAmount > 0;

  const formatAmount = (amount: number) =>
    formatCurrency({ amount, currencyCode, minDecimalPlaces: 2 });

  return (
    <Box
      sx={{
        backgroundColor: Colors.White,
        borderRadius: "12px",
        padding: "20px 16px",
        boxShadow:
          " 0px 2px 6px 2px rgba(0, 0, 0, 0.15), 0px 1px 2px 0px rgba(0, 0, 0, 0.3)",
      }}
    >
      <Stack gap={6}>
        <Stack alignItems="center" gap={1}>
          <Typography
            fontSize={16}
            fontWeight={500}
            lineHeight="24px"
            color={Colors.DarkGrey}
            textAlign="center"
          >
            {t(PageResources.Amount)}
          </Typography>
          <Typography
            fontSize={36}
            fontWeight={400}
            lineHeight="40px"
            color={Colors.Text}
            textAlign="center"
          >
            {formatAmount(total)}
          </Typography>
        </Stack>
        <Box px={2}>
          <Divider sx={{ borderColor: Colors.Border }} />
        </Box>
        <Stack gap={2} px={2}>
          <Stack direction="row" justifyContent="space-between">
            <Typography
              fontSize={16}
              fontWeight={400}
              lineHeight="24px"
              color={Colors.DarkGrey}
            >
              {t(PageResources.BillAmount)}
            </Typography>
            <Typography
              fontSize={16}
              fontWeight={500}
              lineHeight="24px"
              color={Colors.Text}
            >
              {formatAmount(billAmount)}
            </Typography>
          </Stack>
          {arePayPointTipsEnabled && (
            <Stack direction="row" justifyContent="space-between">
              <Typography
                fontSize={16}
                fontWeight={400}
                lineHeight="24px"
                color={Colors.DarkGrey}
              >
                {t(PageResources.Tip)}
              </Typography>
              <Typography
                fontSize={16}
                fontWeight={500}
                lineHeight="24px"
                color={hasTip ? Colors.SuccessDark : Colors.Text}
              >
                {hasTip ? `+${formatAmount(tipAmount)}` : formatAmount(0)}
              </Typography>
            </Stack>
          )}
        </Stack>
      </Stack>
    </Box>
  );
};
